import { ITranslationEntry } from '../lang';

export const NO: ITranslationEntry = {
  translations: {
    notifications: 'Varsler',
    markAllAsRead: 'Marker alle som lest',
    poweredBy: 'drevet av',
    settings: 'innstillinger',
  },
  lang: 'no',
};
